<template>
    <div>
        <div class="">
            <div class="nodata flex justify-center align-center flex-direction">
                <img src="/static/assets/images/empty.png" style="width: 150px;height: 150px;">
                <div class="" style="font-size: 18px">
                    {{text}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return{
            
        }
    },
    props: {
      text: {
        type: [String],
        default: '暂无数据'
      }
    },
}
</script>



// WEBPACK FOOTER //
// nomore.vue?5689d9c9